/**
 * Anonymous reviewers (AI-1255): s.base sends `anonymous: true` and masks the name. Every surface
 * shows the translated `propertypage.reviews.anonymoususer` label ("Anonymous Student") and a generic
 * avatar, never the name, initials or profile picture. A review that simply has no name keeps the
 * older `propertypage.reviews.anonymous` ("Anonymous"). The English constant is only the JSON-LD
 * author fallback.
 */
export const ANONYMOUS_REVIEWER_NAME = "Anonymous Student";
export const ANONYMOUS_REVIEWER_KEY = "propertypage.reviews.anonymoususer";
export const NAMELESS_REVIEWER_KEY = "propertypage.reviews.anonymous";

export const isAnonymousReview = (review?: { anonymous?: boolean } | null): boolean =>
  review?.anonymous === true;
